import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const GlobalNetwork = () => {
  return (
    <div className="flex justify-center ">
      <div className="px-[150px] pb-[80px] w-[1920px]">
        <PageTitle title="我们的全球骨干网络" />
        <PageSubTitle title="采用全自研K-WAN组网系统，网络资源覆盖全球180多个国家与地区，可以让企业接入加速网路，快速访问!工作效率倍升!" />
        <img src="/imgs/kwan/global.png" className="w-[100%] mt-[140px]" />
      </div>
    </div>
  );
};
